import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import { getAllUsers } from "../../services/api/userAdministration.api";
import { MessageCard } from "../../components/MessageCard";
import { ListItem, Button, TextField } from "@material-ui/core";
import { PowUserResponse } from "../../models/Administration";
import { UserDisplayCard } from "../../components/Administration/UserPages/UserDisplayCard";
import { toUserEditPage } from "../../router/navigation";
import { useHistory } from "react-router-dom";
import colors from "../../constants/colors";

const useStyles = makeStyles((theme) => ({
	titleWrapper: {
		maxWidth: theme.breakpoints.values.md,
		display: "flex",
		justifyContent: "space-between",
	},
	title: {
		marginBottom: theme.spacing(3),
	},
	list: {
		maxWidth: theme.breakpoints.values.md,
	},
	addUserButton: {
		marginRight: theme.spacing(2),
	},
	textFieldLabel: {
		fontSize: 14,
		letterSpacing: "0.1em",
		margin: 0,
		textTransform: "uppercase" as any,
		color: colors.gray600,
	},
	textField: {
		width: "100%",
	},
	searchWrapper: {
		maxWidth: theme.breakpoints.values.md,
		display: "flex",
		marginBottom: 20,
		padding: theme.spacing(2),
	},
}));

function filterUsers(data: PowUserResponse[], userNameFilter: string) {
	return !userNameFilter
		? data
		: data.filter((user) => user.userPrincipalName.toLowerCase().includes(userNameFilter.toLowerCase()));
}

const renderPage = (data: PowUserResponse[], classes: Record<any, string>) => {
	return (
		<div data-testid="user-list">
			{data && data.length > 0 ? (
				<div>
					<List className={classes.list}>
						{data.map((user) => (
							<ListItem key={user.userPrincipalName} data-testid="user-list-item">
								<UserDisplayCard user={user}></UserDisplayCard>
							</ListItem>
						))}
					</List>
				</div>
			) : (
				<MessageCard message="No users found." textAlign="left" />
			)}
		</div>
	);
};

/**
 * Fetch and display all pow users in the system in a list
 */
export const UserListPage = () => {
	const [userNameFilter, setUserNameFilter] = React.useState("");
	const [users, setUsers] = React.useState<PowUserResponse[]>([]);

	const classes = useStyles();
	const history = useHistory();

	React.useEffect(() => {
		const getData = async () => {
			setUsers((await getAllUsers()()).data);
		};
		if (users.length === 0) {
			getData();
		}
	}, [users]);

	return (
		<div>
			<div className={classes.titleWrapper}>
				<Typography className={classes.title} variant="h4" data-testid="user-list-page">
					Users
				</Typography>
				<div>
					<div className={classes.addUserButton} data-testid="user-add-button">
						<Button size="small" variant="outlined" color="primary" onClick={() => history.push(toUserEditPage("new"))}>
							Add User
						</Button>
					</div>
				</div>
			</div>
			<div className={classes.searchWrapper}>
				<TextField
					inputProps={{ "data-testid": "user-name-input" }}
					type="text"
					value={userNameFilter}
					className={classes.textField}
					label={<span className={classes.textFieldLabel}>Search by user name</span>}
					InputLabelProps={{ shrink: true }}
					placeholder="e.g. John Doe"
					onChange={(e) => {
						setUserNameFilter(e.target.value);
					}}
				/>
			</div>
			{renderPage(filterUsers(users, userNameFilter), classes)}
		</div>
	);
};
